/* 🤖 this file was generated by svg-to-ts */
export const matIconApi: {
  name: 'api';
  data: string;
} = {
  name: 'api',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m14 12-2 2-2-2 2-2 2 2zm-2-6 2.12 2.12 2.5-2.5L12 1 7.38 5.62l2.5 2.5L12 6zm-6 6 2.12-2.12-2.5-2.5L1 12l4.62 4.62 2.5-2.5L6 12zm12 0-2.12 2.12 2.5 2.5L23 12l-4.62-4.62-2.5 2.5L18 12zm-6 6-2.12-2.12-2.5 2.5L12 23l4.62-4.62-2.5-2.5L12 18z"/></svg>`
};
